import {
	generatePhoneCert,
	checkPhoneCert,
	signUp,
	login,
	saveClauses,
} from '@/api/member';

export default {
	async GENERATE_PHONE_CERT(_context, payload) {
		const response = await generatePhoneCert(payload);
		if (response) {
			return response.data.data;
		}
	},
	async CHECK_PHONE_CERT(_context, payload) {
		const response = await checkPhoneCert(payload);
		if (response) {
			return response.data.data;
		}
	},
	async SET_USER_INFO({ commit }, payload) {
		commit('SET_USER_INFO', payload);
	},
	async SET_CLAUSES({ commit }, payload) {
		commit('SET_CLAUSES', payload);
	},
	async SIGN_UP({ commit }, payload) {
		const response = await signUp(payload);
		if (response.data.resultCode === 0) {
			commit('SET_USER_INFO', response.data.data);
			commit('SET_ACCESS_TOKEN', response.data.data.accessToken);
		}
		return response.data;
	},
	async CLEAR_ACCESS_TOKEN({ commit }) {
		commit('SET_ACCESS_TOKEN', '');
	},
	async LOGIN({ commit }, payload) {
		const response = await login(payload);
		if (response.data.resultCode === 0) {
			commit('SET_ACCESS_TOKEN', response.data.data.accessToken);
			return response.data.data;
		}
	},
	async SET_ACCESS_TOKEN({ commit }, payload) {
		commit('SET_ACCESS_TOKEN', payload);
	},
	async CLEAR_USER_INFO({ commit }) {
		commit('CLEAR_USER_INFO');
	},

	async SAVE_CLAUSES(_context, payload) {
		const response = await saveClauses(payload);
		if (response) {
			return response.data.data;
		}
	},
};
